import type { Editor } from "@tiptap/core";
import type { Range } from "@tiptap/core";

type OpenBookmarkModalFn = (
  editor: Editor,
  range: Range,
  position?: { top: number; left: number },
  /** Connector id from lib/embed-connectors, for the per-app copy. */
  provider?: string | null
) => void;

let openBookmarkModalFn: OpenBookmarkModalFn | null = null;

export function setOpenBookmarkModal(fn: OpenBookmarkModalFn | null) {
  openBookmarkModalFn = fn;
}

export function openBookmarkModal(
  editor: Editor,
  range: Range,
  position?: { top: number; left: number },
  provider?: string | null
) {
  if (openBookmarkModalFn) {
    openBookmarkModalFn(editor, range, position, provider);
  } else {
    console.warn("BookmarkModal not initialized.");
  }
}
